import React from 'react';
import classes from './Categories.module.scss'

const CategoriesHook = (props) => {

    let otherProductCategory = '';
    if( props.data !== undefined){
        otherProductCategory = props.data.map((item, index) => {
            return (
                <li className={[""].join(' ')}
                    key={`${item.id}${index}`} onClick={() => props.gotoSomewhere(item.slug, item.id, 0, 0, item.name)}>
                    <div className={classes.Items_component}>
                        <div className={classes.Items_pipe}/>
                        <div>{item.name.toUpperCase()}</div>
                    </div>
                </li>
            );
        });
    }else{
        otherProductCategory = props.product_categories.map((item, index) => {
            return (
                <li
                    key={`${item.product_category_cd}${index}`}
                    onClick={() => props.goRefresh(item.slug, item.id, 0, 0, item.name)}>
                    <div className={classes.Items_component}>
                        <div className={classes.Items_pipe}/>
                        <div>{item.name.toUpperCase()}</div>
                    </div>
                </li>
            );
        });
    }

    return (
        <ul className={classes.List_container}>
            {otherProductCategory}
        </ul>
    );
}

export default CategoriesHook;